import * as React from "react";

import {
  Box,
  Button,
  Collapse,
  Container,
  Text,
  Flex,
  Icon,
  Link,
  useColorModeValue,
  useDisclosure,
  Image,
  Stack,
} from "@chakra-ui/react";
import { ChevronDownIcon, CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import { IconMenu2 } from "@tabler/icons-react";

import { DocumentPopover } from "./DocumentPopover";
import Headroom from "react-headroom";
import { Logo } from "../../atoms/Logo/Logo";
import styled from "styled-components";

const Div = styled.div`
  .headroom {
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
  }
  .headroom--unfixed {
    position: relative;
    transform: translateY(0);
    background-color: transparent;
  }
  .headroom--scrolled {
    transition: transform 200ms ease-in-out;
    background: #fff;
    z-index: 999;
  }
  .headroom--unpinned {
    position: fixed;
    transform: translateY(-100%);
    background: transparent;
  }
  .headroom--pinned {
    position: fixed;
    z-index: 999 !important;
    background: #fff;
  }
  .headroom-wrapper {
    position: relative;
    width: 100%;
    z-index: 9999;
  }
`;

export const Header = () => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Div>
      <Headroom
        style={{
          width: "100%",
        }}
      >
        <Box w={"100%"}>
          <Flex
            bg={useColorModeValue("white", "gray.800")}
            color={useColorModeValue("gray.600", "white")}
            minH={"100px"}
            maxW={"100%"}
            px={{ base: 4, xl: 16 }}
            justify={"space-between"}
            borderBottom={1}
            borderStyle={"solid"}
            borderColor={useColorModeValue("gray.200", "gray.900")}
            align={"center"}
          >
            <Flex flex={{ base: 1 }} justify={{ base: "center", xl: "start" }}>
              <Link href="/" display={"flex"} alignItems={"center"}>
                <Logo
                  width={{ base: "234px", xl: "18rem" }}
                  height={{ base: "26px", xl: "2rem" }}
                  display="flex"
                  justifyContent="center"
                  alignContent="center"
                />
              </Link>
              <Button
                flex={{ base: 1, xl: "auto" }}
                display={{ base: "flex", xl: "none" }}
                justifyContent={"flex-end"}
                color={"#09170D"}
                bg={"transparent"}
                _hover={{ bg: "transparent" }}
                variant={"ghost"}
                p={0}
                aria-label="icon"
              >
                <IconMenu2 onClick={onToggle} width={"40px"} height={"40px"} />
              </Button>
            </Flex>
            <Flex
              display={{ base: "none", xl: "flex" }}
              borderRight="1px solid #C0C9C2"
            >
              <DesktopNav />
            </Flex>
            <Stack
              flex={{ base: 1, xl: 0 }}
              justify={"flex-end"}
              align={"center"}
              direction={"row"}
              spacing={6}
              display={{ base: "none", xl: "inline-flex" }}
            >
              {/* <Image
                src="/eng.svg"
                display="flex"
                justifyContent="center"
                alignItems="center"
                w="30px"
                h="30px"
                mr={"25px"}
                ml={"40px"}
                borderRadius="50%"
              /> */}
              <Link _hover={{ textDecoration: "none" }} href="/get-involved">
                <Button
                  as={"a"}
                  fontWeight={700}
                  // display={{ base: "none", xl: "inline-flex" }}
                  color={"black"}
                  fontFamily="TradeGothic LT"
                  variant={"link"}
                  border="1.5px solid #09170D"
                  borderRadius="0"
                  px={6}
                  aria-label="get-involved"
                  _hover={{ textDecoration: "none", bg: "#000", color: "#fff" }}
                >
                  Get Involved
                </Button>
              </Link>
              <Link
                _hover={{ textDecoration: "none" }}
                href="https://donate.globaltiesalabama.org/donate/"
              >
                <Button
                  as={"a"}
                  // display={{ base: "none", xl: "inline-flex" }}
                  fontWeight={600}
                  color={"white"}
                  bg={"#D9A542"}
                  borderRadius="0"
                  // h="40px"
                  px={6}
                  aria-label="donate-button"
                  textTransform="uppercase"
                >
                  Donate
                </Button>
              </Link>
            </Stack>
          </Flex>
          <Collapse in={isOpen} animateOpacity>
            <MobileNav />
          </Collapse>
        </Box>
      </Headroom>
    </Div>
  );
};

const DesktopNav = () => {
  return (
    <Stack direction={"row"} alignItems={"center"}>
      <Box>
        {/* <DocumentPopover label={"About"} /> */}
        <Button
          fontSize={"sm"}
          mr={10}
          px={0}
          textTransform="uppercase"
          bg="transparent"
          aria-label="programs"
          _hover={{ bg: "transparent", color: "#817C25" }}
        >
          <Link href="/" _hover={{ textDecoration: "none" }}>
            Home
          </Link>
        </Button>
        <Button
          fontSize={"sm"}
          mr={10}
          px={0}
          textTransform="uppercase"
          bg="transparent"
          aria-label="programs"
          _hover={{ bg: "transparent", color: "#817C25" }}
        >
          <Link href="/board-members" _hover={{ textDecoration: "none" }}>
            Team
          </Link>
        </Button>
        {/* <Button
          fontSize={"sm"}
          mr={10}
          px={0}
          textTransform="uppercase"
          bg="transparent"
          aria-label="events"
          _hover={{ bg: "transparent", color: "#817C25" }}
        >
          <Link href="/events" _hover={{ textDecoration: "none" }}>
            Events
          </Link>
        </Button>
        <DocumentPopover label={"News"} />
        <Button
          fontSize={"sm"}
          mr={10}
          px={0}
          textTransform="uppercase"
          bg="transparent"
          aria-label="refugee-program"
          _hover={{ bg: "transparent", color: "#817C25" }}
        >
          <Link
            href="/refugee-resettlement-program"
            _hover={{ textDecoration: "none" }}
          >
            Refugee Program
          </Link>
        </Button> */}
      </Box>
    </Stack>
  );
};

const MobileNav = () => {
  return (
    <Stack
      bg={useColorModeValue("white", "gray.800")}
      p={4}
      display={{ base: "flex", xl: "none" }}
      flexDir="column"
      alignItems={"center"}
    >
      {NAV_ITEMS.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}
      <Link _hover={{ textDecoration: "none" }} href="/get-involved">
        <Button
          as={"a"}
          fontWeight={700}
          fontFamily="TradeGothic LT"
          fontSize={"sm"}
          variant={"ghost"}
          border="1.5px solid #09170D"
          borderRadius="0"
          px={6}
          aria-label="get-involved"
          _hover={{ textDecoration: "none", bg: "#000", color: "#fff" }}
        >
          Get Involved
        </Button>
      </Link>
      <Link
        _hover={{ textDecoration: "none" }}
        href="https://donate.globaltiesalabama.org/donate/"
      >
        <Button
          as={"a"}
          fontWeight={600}
          fontSize={"sm"}
          color={"white"}
          bg={"#D9A542"}
          borderRadius="0"
          px={6}
          aria-label="donate"
          textTransform="uppercase"
          w="343px"
        >
          Donate
        </Button>
      </Link>
    </Stack>
  );
};

const MobileNavItem = ({ label, children, href }: NavItem) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Flex
        py={2}
        as={Link}
        href={href ?? ""}
        justify={"space-between"}
        align={"center"}
        _hover={{
          textDecoration: "none",
        }}
      >
        <Text
          fontWeight={"bold"}
          color={useColorModeValue("gray.600", "gray.200")}
        >
          {label}
        </Text>
        {children && (
          <Icon
            as={ChevronDownIcon}
            transition={"all .25s ease-in-out"}
            transform={isOpen ? "rotate(180deg)" : ""}
            w={6}
            h={6}
          />
        )}
      </Flex>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: "0!important" }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={"solid"}
          borderColor={useColorModeValue("gray.200", "gray.700")}
          align={"start"}
        >
          {children &&
            children.map((child) => (
              <Link key={child.label} py={2} href={child.href}>
                {child.label}
              </Link>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};

interface NavItem {
  label: string;
  subLabel?: string;
  children?: Array<NavItem>;
  href?: string;
  isFirstLink?: boolean;
}

const NAV_ITEMS: Array<NavItem> = [
  {
    label: "HOME",
    href: "/",
    isFirstLink: true,
  },
  {
    label: "TEAM",
    href: "/board-members",
  },
];
